import {
  BUDGET_LOADING,
  GET_BUDGET,
  GET_BUDGET_SUCCESS,
  GET_BUDGET_FAIL,
  ADD_BUDGET_SUCCESS,
  ADD_BUDGET_FAIL,
  DELETE_BUDGET_SUCCESS,
  DELETE_BUDGET_FAIL,
  UPDATE_BUDGET_SUCCESS,
  UPDATE_BUDGET_FAIL,
  BUDGET_RESET
} from "./actionType";

const INIT_STATE = {
  budgets: [],
  error: {},
};

const Budget = (state = INIT_STATE, action) => {
  switch (action.type) {
    case GET_BUDGET_SUCCESS:
      switch (action.payload.actionType) {
        case GET_BUDGET:
          return {
            ...state,
            budgets: action.payload.data,
            isBudgetCreated: false,
            isBudgetSuccess: true,
            loading: false,
          };

        default:
          return { ...state };
      }
    case GET_BUDGET_FAIL:
      switch (action.payload.actionType) {
        case GET_BUDGET_FAIL:
          return {
            ...state,
            error: action.payload.error,
            isBudgetCreated: false,
            isBudgetSuccess: false,
            loading: false,
          };
        default:
          return { ...state };
      }

    case GET_BUDGET: {
      return {
        ...state,
        isBudgetCreated: false,
        loading: true,
      };
    }

    case BUDGET_LOADING: {
      return {
        ...state,
        isBudgetCreated: false,
        loading: true,
      };
    }

    case ADD_BUDGET_SUCCESS:
      return {
        ...state,
        isBudgetCreated: true,
        loading: false,
        budgets: [action.payload.data, ...state.budgets],
      };

    case ADD_BUDGET_FAIL:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };

    case DELETE_BUDGET_SUCCESS:
      return {
        ...state,
        loading: false,
        isBudgetCreated: true,
        budgets: state.budgets.filter(
          budget => budget.id.toString() !== action.payload.id.toString()
        ),
      };

    case DELETE_BUDGET_FAIL:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };

    case UPDATE_BUDGET_SUCCESS:
      return {
        ...state,
        loading: false,
        isBudgetCreated: true,
        budgets: state.budgets.map(budget =>
          budget.id.toString() === action.payload.data.id.toString() ? { ...budget, ...action.payload.data } : budget
        ),
      };

    case UPDATE_BUDGET_FAIL:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };

    case BUDGET_RESET:
      return INIT_STATE;

    default:
      return { ...state };
  }
};

export default Budget;